<template>
  <div>
    <br />


    <div class="row">

      <div class="col-3 my-3">
        <label for=""> Poid T</label>
        <input type="text" v-model="delivery.tareWeight" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for=""> Poid B </label>
        <input type="text" v-model="delivery.grossWeight" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for="">Chauffeur</label>
        <vue-select :options="employees.filter(p => p.fonction == 'Chauffeur')" v-model="delivery.deliveredBy_reference"
          labelColumn="fullName" valueColumn="reference" />
      </div>

      <div class="col-3 my-3">
        <label for="">Entreé de chargement</label>
        <input type="datetime-local" v-model="delivery.startChargeDatetime" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for="">Sortie de chargement</label>
        <input type="datetime-local" v-model="delivery.deliveryDateTime" class="form-control">
      </div>



      <div class="col-3 my-3">
        <label for="">Véhicule</label>
        <vue-select :options="vehicles" v-model="delivery.deliveryVehicle_reference" labelColumn="fullName"
          valueColumn="reference" />
      </div>

      <div class="col-12 my-3">
        <label for="">Remarque</label>
        <textarea class="form-control" v-model="delivery.remark"></textarea>
      </div>
    </div>


    <br />


    <button class="btn btn-success" @click="save(delivery)">
      <i class="bi bi-check-square-fill"></i> Enregistrer
    </button>
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: ' Total ', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      delivery: {}
    };
  },

  async beforeCreate() {
    await this.$store.dispatch("employee/getAll");
    await this.$store.dispatch("vehicle/getAll");
  },
  computed: {

    ...mapGetters("employee", {
      employees: "getAll",
    }),

    ...mapGetters("vehicle", {
      vehicles: "getVehicles",
    }),
  },
  methods: {
    async refresh() {
    },
    async save(delivery) {
      await this.$store.dispatch("delivery/store", delivery);
    },

  },
};
</script>
